var __TEMP__ = require('./_createBaseFor.js');var createBaseFor = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseFor;
